import PerfTimer from './PerfTimer';

class PerfTimingService {
  timings = {};

  addTime = (key, t) => {
    let a = this.timings[key];
    if (!a) {
      a = [];
      this.timings[key] = a;
    }

    a.push(t);
  }

  getAverageTime = (key) => {
    const arr = this.timings[key];
    return arr.reduce((a, b) => a + b, 0) / arr.length;
  }

  newTimer = key => new PerfTimer(this, key);
}

export default PerfTimingService;
